import { useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ;

export const useApi = () => {
  const { getToken } = useAuth();

  const api = useCallback(async (config) => {
    try {
      const token = await getToken();
      const headers = {
        ...config.headers,
      };

      // Only set Content-Type to application/json if data is not FormData and not already set
      if (
        !(config.data instanceof FormData) &&
        !headers['Content-Type']
      ) {
        headers['Content-Type'] = 'application/json';
      }

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await axios({
        ...config,
        baseURL: API_BASE_URL,
        headers,
      });

      return response;
    } catch (error) {
      if (error.response?.status === 401) {
        window.location.href = '/sign-in';
      }
      throw error;
    }
  }, [getToken]);

  return api;
}; 